module.exports = __webpack_public_path__ + "static/img/012.00268f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-yongdong/012.png
// module id = aXCM
// module chunks = 1